var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { CheckmarkCircleFillIcon, ExclamationmarkTriangleFillIcon, InformationSquareFillIcon, XMarkIcon, XMarkOctagonFillIcon, } from "@navikt/aksel-icons";
import { Button } from "../button/index.js";
import { useRenameCSS } from "../theme/Theme.js";
import { BodyLong } from "../typography/index.js";
import { useI18n } from "../util/i18n/i18n.hooks.js";
const IconMap = {
    error: XMarkOctagonFillIcon,
    warning: ExclamationmarkTriangleFillIcon,
    info: InformationSquareFillIcon,
    success: CheckmarkCircleFillIcon,
};
/**
 * A component for displaying alerts
 * @see [📝 Documentation](https://aksel.nav.no/komponenter/core/alert)
 * @see 🏷️ {@link AlertProps}
 * @example
 * ```jsx
 * <Alert variant="error">Dette er en feilmelding</Alert>
 * ```
 */
export const Alert = forwardRef((_a, ref) => {
    var { children, className, variant, size = "medium", fullWidth = false, contentMaxWidth = true, inline = false, closeButton = false, onClose } = _a, rest = __rest(_a, ["children", "className", "variant", "size", "fullWidth", "contentMaxWidth", "inline", "closeButton", "onClose"]);
    const { cn } = useRenameCSS();
    const translate = useI18n("global");
    const Icon = IconMap[variant];
    return (React.createElement("div", Object.assign({}, rest, { "data-color": variantToRole(variant), "data-variant": variant, ref: ref, className: cn(className, "navds-alert", `navds-alert--${variant}`, `navds-alert--${size}`, {
            "navds-alert--full-width": fullWidth,
            "navds-alert--inline": inline,
            "navds-alert--close-button": closeButton,
        }) }),
        React.createElement(Icon, { title: translate(variant), className: cn("navds-alert__icon") }),
        React.createElement(BodyLong, { as: "div", size: size, className: cn("navds-alert__wrapper", contentMaxWidth && "navds-alert__wrapper--maxwidth") }, children),
        closeButton && !inline && (React.createElement("div", { className: cn("navds-alert__button-wrapper") },
            React.createElement(Button, { className: cn("navds-alert__button"), size: "small", variant: "tertiary-neutral", onClick: onClose, type: "button", icon: React.createElement(XMarkIcon, { title: translate("close") }) })))));
});
function variantToRole(variant) {
    switch (variant) {
        case "warning":
            return "warning";
        case "error":
            return "danger";
        case "info":
            return "info";
        case "success":
            return "success";
        default:
            return "info";
    }
}
export default Alert;
//# sourceMappingURL=Alert.js.map